import React from 'react'
import { BsArrowLeft } from 'react-icons/bs'
import FormFactory from '../../../components/form/form-factory'

import {
  Container, Wrapper, Greetings, FormWrapper, Heading, FormContent, Footer,
} from './styles'

import LogoSvg from '../../../assets/svg/logo.svg'
import { theme } from '../../../styles/theme'
import IFormPage, { IDataForm } from '../../../interfaces/form-page'

type IProps = any & IFormPage & {
  dataFormCode: IDataForm;
  onSubmitCode: () => void;
  goBack: () => void;
  code: string | null;
}

const RecoveryPassword = ({
  dataForm,
  dataFormCode,
  onSubmit,
  errorMessage,
  onSubmitCode,
  goBack,
  code,
}: IProps): JSX.Element => (
  <Container>
    <Wrapper>
      <Greetings>
        <h1>Recuperar a Senha!</h1>
        <p>Informe o código para poder recuperar a senha</p>
      </Greetings>

      <FormWrapper action="">
        <FormContent>
          <Heading>
            <button type="button" onClick={goBack}>
              <BsArrowLeft size={24} color={theme.colors.brown} />
            </button>
            <h2>Recuperar a Senha - Gestor</h2>
          </Heading>
          {
            code
              ? (
                <FormFactory
                  data={dataForm}
                  onSubmit={onSubmit}
                  submitErrorMessage={errorMessage}
                />
              )
              : (<FormFactory data={dataFormCode} onSubmit={onSubmitCode} />)
          }
        </FormContent>
      </FormWrapper>
    </Wrapper>

    <Footer>
      <img src={LogoSvg} alt="FingerMenu logo" />
    </Footer>
  </Container>
)

export default RecoveryPassword
